import React from 'react';
export function ProblemSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-246">
      <div className="max-w-3xl mx-auto" data-id="element-247">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#5B3FA0]" data-id="element-248">
          EL PROBLEMA QUE MUCHOS DOCENTES DE SECUNDARIA VIVEN CADA AÑO
        </h2>

        <p className="text-xl mb-3 font-medium text-center md:text-left" data-id="element-249"></p>

        <ul className="space-y-2 text-lg text-gray-700 mb-5 max-w-2xl mx-auto" data-id="element-250">
          <li className="flex items-start" data-id="element-251">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-252">•</span>
            <span data-id="element-253">
              Llega el momento de trabajar ESI y no sabés por dónde empezar.
            </span>
          </li>
          <li className="flex items-start" data-id="element-254">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-255">•</span>
            <span data-id="element-256">Encontrás materiales pensados para primaria.</span>
          </li>
          <li className="flex items-start" data-id="element-257">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-258">•</span>
            <span data-id="element-259">
              Terminás adaptando recursos que no fueron creados para
              adolescentes.
            </span>
          </li>
          <li className="flex items-start" data-id="element-260">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-261">•</span>
            <span data-id="element-262">
              Improvisás actividades porque no encontrás propuestas claras.
            </span>
          </li>
          <li className="flex items-start" data-id="element-263">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-264">•</span>
            <span data-id="element-265">Te cuesta abordar temas sensibles con seguridad.</span>
          </li>
        </ul>

        <p className="text-xl text-center mb-3 font-[800] text-[#2E9E8F]" data-id="element-266">
          Lo peor es esa sensación de pensar: "Podría trabajar mucho mejor estos
          temas si tuviera todo listo."
        </p>
      </div>
    </section>;
}